module.exports = __webpack_public_path__ + "img/Frame 1055five.359d9d50.png";